import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { ChevronDown, ChevronUp, Search } from "react-feather"
import { displayValueFunction, getIcon, getNestedValue } from "./AnalyticsUtils";
import { PAGES, ROUTE_PATHS } from "../../InternalApiApp";
import LoadingIcon from "../Shared/LoadingIcon";
import Tooltip from "../../components/popups/Tooltip";
import SimpleSearchFilter from "../../components/Input/SimpleSearchFilter";
import PageGridItem from "../Shared/Page/PageGridItem";
import FlexWrapper from "../FlexWrapper";
import PageContentToggle from "../../components/Menus/PageContentToggle";
import Divider from "../../components/Divider";
import './AnalyticsPage.scss'


const AnalyticsGenericTable = (props) => {
    const { noResults, searchable, filterable, currentFilter, title, tableStyle, colWidths, headers, columns, data, initialSort, individualPagePath, loading, searchPlaceholder, toggleTabs, selectedTab, setSelectedTab } = props
    const history = useHistory()
    const [sortingColumn, setSortingColumn] = useState({ column: initialSort.column, ascending: initialSort.ascending })
    const [filterTerm, setFilterTerm] = useState("")
    const [searchedData, setSearchedData] = useState(null)
    const [filteredData, setFilteredData] = useState(null)
    const [displayedData, setDisplayedData] = useState(null)
    const [notFound, setNotFound] = useState(false)

    useEffect(() => {
        if (!!filterable) filterByFilter()
    }, [currentFilter, data, filterable])

    useEffect(() => {
        if (!!searchable) filterBySearch()
    }, [data, filterTerm, filteredData, searchable])

    useEffect(() => {
        if (data && data.length > 0) {
            sortTable(initialSort.column, initialSort.type, initialSort.ascending)
        } else {
            setDisplayedData([])
            setNotFound(true)
        }
    }, [searchedData, filteredData])

    useEffect(() => {
        if (displayedData && displayedData.length === 0) setNotFound(true)
        else setNotFound(false)
    }, [displayedData])


    // Filter functionality
    function filterByFilter() {
        let newList = data
        const arrayOfKeysToFilterBy = filterable.keys

        if (currentFilter.length > 0) {
            newList = data && data.filter(l => {
                return arrayOfKeysToFilterBy.find(k => l[k] === currentFilter)
            })
        }
        setFilteredData(newList)
    }

    // Search functionality
    function filterBySearch() {
        let newList = !!filterable ? filteredData : data

        if (filterTerm.length > 0) {
            newList = newList.filter(l => {
                return searchable.find(k => {
                    if (k.includes(".")) {
                        const val = getNestedValue(l, k)
                        return val.toLowerCase().includes(filterTerm.toLowerCase())
                    } else return l[k].toLowerCase().includes(filterTerm.toLowerCase())
                })
            })
        }
        setSearchedData(newList)
    }

    // Sortable functionality
    function sortTable(column, type, initialAcsending) {
        let tableData = []
        if (searchable && filterTerm && filterTerm.length > 0) tableData = [...searchedData]
        else if (filterable && filterable.currentFilter && filterable.currentFilter !== '') tableData = filteredData
        else tableData = data

        const ascending = initialAcsending === null ? sortingColumn.column === column ? !sortingColumn.ascending : true : initialAcsending

        tableData.sort((a, b) => {
            if (column.includes(".")) {
                const keyArray = column.split(".")
                const parentDatum1 = a[keyArray[0]]
                const parentDatum2 = b[keyArray[0]]
                const datum1 = parentDatum1[keyArray[1]] === null ? type === 'number' ? 0 : "-" : parentDatum1[keyArray[1]]
                const datum2 = parentDatum2[keyArray[1]] === null ? type === 'number' ? 0 : "-" : parentDatum2[keyArray[1]]

                if (type === 'number') return ascending ? datum1 - datum2 : datum2 - datum1
                else return ascending ? datum1.localeCompare(datum2) : datum2.localeCompare(datum1)

            } else if (column && typeof column === 'object' && column.length > 1) {
                if (type === 'number') {
                    const datum1 = a[column[0]] + a[column[1]]
                    const datum2 = b[column[0]] + b[column[1]]
                    return ascending ? datum1 - datum2 : datum2 - datum1
                } else {
                    const datum1 = a[column[0]] + " " + a[column[1]]
                    const datum2 = b[column[0]] + " " + b[column[1]]
                    ascending ? datum1.localeCompare(datum2) : datum2.localeCompare(datum1)
                }

            } else {
                const datum1 = a[column] === null ? type === 'number' ? 0 : "-" : a[column]
                const datum2 = b[column] === null ? type === 'number' ? 0 : "-" : b[column]
                if (type === 'number') return ascending ? datum1 - datum2 : datum2 - datum1
                else return ascending ? datum1.localeCompare(datum2) : datum2.localeCompare(datum1)
            }
        })

        setSortingColumn({ column: column, ascending: ascending })
        setDisplayedData(tableData)
    }

    function getPath(datum) {
        const pathArray = individualPagePath.path.split(":")
        const path = `${ROUTE_PATHS[PAGES.ANALYTICS]}${pathArray[0]}${datum[pathArray[1]]}`
        return path
    }

    // Render
    if (loading) return <LoadingIcon centered header="Loading" size={50} />

    return (
        <div>
            {searchable &&
                <PageGridItem style={{ paddingTop: "1.5rem", paddingBottom: title ? 0 : "1.5rem" }}>
                    {toggleTabs
                        ? (
                            <FlexWrapper gap="m">
                                <PageContentToggle labels={toggleTabs.map(tab => {
                                    return { label: tab, active: selectedTab === tab, onClick: () => setSelectedTab(tab) }
                                })} />
                                <Divider vertical height={24} />
                                <SimpleSearchFilter
                                    size='small'
                                    width="l"
                                    placeholder={searchPlaceholder}
                                    isClearable
                                    icon={<Search />}
                                    setSearchTerm={setFilterTerm}
                                    searchTerm={filterTerm}
                                    disabled={data?.length === 0}
                                />
                            </FlexWrapper>
                        ) : (
                            <SimpleSearchFilter
                                size='small'
                                width="l"
                                placeholder={searchPlaceholder}
                                isClearable
                                icon={<Search />}
                                setSearchTerm={setFilterTerm}
                                searchTerm={filterTerm}
                                disabled={data?.length === 0}
                            />
                        )
                    }
                </PageGridItem>
            }
            {title && <div className="table-title">{title}</div>}

            {notFound ?
                <div className="fade-in-slower no-results-message">
                    <h3 >{noResults && noResults.message || "No results found"} </h3>
                    <p style={{ opacity: 0.6 }}>{noResults && noResults.subMessage ? noResults.subMessage : "Sorry, we couldn't find any matches"}</p>
                </div> :
                <div className={`table-wrapper`}>
                    <table className="analytics-table" style={tableStyle}>
                        {colWidths && (
                            <colgroup>
                                {colWidths.map((width, idx) => (
                                    <col key={"col-" + idx} span="1" style={{ width }} />
                                ))}
                            </colgroup>
                        )}
                        {headers && (
                            <thead className="">
                                <tr className="header-table-row">
                                    {headers.map((header, idx) => {
                                        const { column, icon, iconClassName, label, tooltip, align, type } = header

                                        return (
                                            <th
                                                className={header.className ? header.className : ""}
                                                style={{ width: "auto", textAlign: align, fontWeight: sortingColumn.column === column ? 600 : 400, cursor: 'pointer' }}
                                                key={"header-" + idx}
                                                onClick={() => sortTable(column, type, null)}
                                            >
                                                <Tooltip label={tooltip} disabled={!tooltip}>
                                                    <div className={`sorting-header${sortingColumn.column === column ? "" : " inactive-header"}`} style={{ justifyContent: align }}>
                                                        {getIcon(icon, iconClassName)}
                                                        {label && <div>{label}</div>}
                                                        {sortingColumn && sortingColumn.column === column && sortingColumn.ascending === true ?
                                                            <ChevronUp color="#0d8efd" size={12} /> :
                                                            <ChevronDown color={sortingColumn && sortingColumn.column === column ? "#0d8efd" : "#c2c4ce"} size={12} />
                                                        }
                                                    </div>
                                                </Tooltip>
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                        )}
                        <tbody>
                            {displayedData && displayedData.length > 0 && displayedData.map((datum, index) => {
                                return (
                                    <tr key={"row-" + index} onClick={() => history.push(getPath(datum))}>{
                                        columns.map((c, idx) => {
                                            const { column, displayFunction, align, paddingRight } = c
                                            const value = displayFunction ? displayValueFunction(datum, c) : c.nested ? getNestedValue(datum, column) : datum[column]
                                            return <td key={"cell-" + idx} style={{ textAlign: align }}>{value}</td>
                                        })
                                    }</tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default AnalyticsGenericTable;